export default __webpack_public_path__ + "static/media/individual.c1e3f5b9.svg";